import authorIsabelle from "@/assets/author-isabelle.webp";
import authorCharlie from "@/assets/author-charlie.webp";
import authorJann from "@/assets/author-jann.webp";

export type Author = {
  name: string;
  role: string;
  image: string;
  /** Tailwind object-position class so the face stays in frame when cropped to a circle. */
  imagePosition?: string;
};

export const AUTHORS: Author[] = [
  {
    name: "Isabelle",
    role: "Beraterin Altersvorsorge",
    image: authorIsabelle,
    imagePosition: "object-[20%_center]",
  },
  {
    name: "Charlie",
    role: "Berater Investments",
    image: authorCharlie,
    imagePosition: "object-[75%_center]",
  },
  {
    name: "Jann",
    role: "Berater Vermögensaufbau",
    image: authorJann,
    imagePosition: "object-[center_25%]",
  },
];

// Deterministic author selection so the same slug always maps to the same author.
function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function getAuthorForSlug(slug: string): Author {
  return AUTHORS[hash(slug) % AUTHORS.length];
}
